import { render, staticRenderFns } from "./ProductRfidLinker.vue?vue&type=template&id=9ff4c284&scoped=true&"
import script from "./ProductRfidLinker.vue?vue&type=script&lang=js&"
export * from "./ProductRfidLinker.vue?vue&type=script&lang=js&"
import style0 from "./ProductRfidLinker.vue?vue&type=style&index=0&id=9ff4c284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff4c284",
  null
  
)

export default component.exports